import React, { useState, useContext } from 'react';
import { Typography, TextField, Button, Box } from '@mui/material';
import { default as Grid } from '@mui/material/Grid2';
import { UserContext } from '../../../contexts/UserContext';

export default function Profile() {
    const { user } = useContext(UserContext); // Access user information
    const [input, setInput] = useState({
        phoneNumber: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInput((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Perfil guardado:', input);
    };

    return (
        <Box>
            <Typography variant="h6" gutterBottom>
                Perfil
            </Typography>
            <form onSubmit={handleSubmit} name="profile" method="post">
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12 }}>
                        <TextField
                            variant="standard"
                            fullWidth
                            label="Correo electrónico"
                            value={user?.email || ''}
                            disabled
                            placeholder="Su correo electrónico"
                        />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <TextField
                            variant="standard"
                            fullWidth
                            label="Número de teléfono"
                            name="phoneNumber"
                            value={input.phoneNumber}
                            onChange={handleChange}
                            helperText="Por favor, ingrese su número de teléfono."
                            inputProps={{ autoComplete: "tel-national" }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                        >
                            Guardar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Box>
    );
}
